<template>
    <div class="row">
        <div class="col-md-12">
            <div class="row m-b-1">
                <div class="col-md-6">
                    <h4 class="required">Sales Channel</h4>
                    <el-select v-model="regionModel"
                               :value="regionModel"
                               :disabled="disabled"
                               placeholder="Select a Region">
                        <el-option v-for="region in regions"
                                   :value="region.code"
                                   :key="region.code"
                                   :label="region.title"/>
                    </el-select>
                    <div v-if="!$v.region.required" class="text-danger">
                        Please select a region
                    </div>
                </div>
                <div class="col-md-6">
                    <h4 class="required">PO #</h4>
                    <el-input v-model="orderPoModel"
                              :disabled="disabled"
                              type="text"
                              placeholder="PO #"/>
                    <div v-if="!$v.orderPo.required" class="text-danger">
                        Please input a PO number
                    </div>
                </div>
            </div>
            <div class="row m-b-1">
                <div class="col-md-6">
                    <h4>Order ID</h4>
                    <el-input :value="orderNum"
                              :disabled="true"
                              type="text"
                              placeholder="Order ID"/>
                </div>
                <div class="col-md-6">
                    <h4>D365 Control #</h4>
                    <el-input :value="d365Id"
                              :disabled="true"
                              type="text"
                              placeholder="D365 ID"/>
                </div>
            </div>
            <div v-show="!disabled&&!hideButton" class="row m-b-1">
                <div class="col-md-12 text-right">
                    <app-spinner v-if="isLoading"></app-spinner>
                    <el-button v-else
                               @click="$emit('fetchOrder')"
                               :disabled="invalid"
                               type="primary">
                        Get Order
                    </el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import {
    required,
    numeric,
    minValue,
  } from 'vuelidate/lib/validators';
  import AppSpinner from '../../ui/AppSpinner';
  import {REGIONS} from '../../../lang/en/constants';

  export default {
    name: 'OrderId',
    props: {
      region: {
        required: true,
      },
      orderPo: {
        required: true,
      },
      orderNum: {
        required: true,
      },
      d365Id: {
        required: true,
      },
      isLoading: {
        required: true,
      },
      disabled: {
        required: true,
      },
      hideButton:{
        required:false,
      }
    },
    components: {
      AppSpinner,
    },
    computed: {
      regionModel: {
        get: function() {
          return this.region;
        },
        set: function(value) {
          this.$emit('update:region', value);
        },
      },
      orderPoModel: {
        get: function() {
          return this.orderPo;
        },
        set: function(value) {
          this.$emit('update:orderPo', value);
        },
      },
      invalid: function() {
        return this.$v.$invalid;
      },
    },
    data() {
      return {
        regions: REGIONS,
      };
    },
    validations() {
      return {
        region: {
          required,
        },
        orderPo: {
          required
        },
      };
    },
  };
</script>
